import { render, staticRenderFns } from "./dialogObsReprov.vue?vue&type=template&id=166e8912"
import script from "./dialogObsReprov.vue?vue&type=script&lang=js"
export * from "./dialogObsReprov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports